type ConvertAprResult = { asDecimal: number; asPercent: number };

export const convertApr = (value: number | string): ConvertAprResult => {
  const valueSanitized = String(value).replace(/[^0-9.]/g, '');
  const apr = Math.abs(Number(valueSanitized));

  // we assume an APR of 1 or greater is a percentage, otherwise it's a decimal
  return {
    asDecimal: apr >= 1 ? apr / 100 : apr,
    asPercent: apr >= 1 ? apr : apr * 100,
  };
};
